import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectContract, selectContractLoading, selectLoadingPAU } from '../../../redux/contract/selectors';
import { IconButton } from '@material-ui/core';
import iconEdit from '../../../images/iconEditarLead.svg';
import iconSave from '../../../images/iconGuardar.svg';
import { getContract, getContractByCaseId, updateContractData, updateCustomerData } from '../../../redux/contract/thunks';
import { AditionalInfoForm } from './AditionalInfoForm';
import { convertToLocalTime } from '../../../commonFunctions/commonFunctions';
import dayjs from 'dayjs';
import { openModal } from '../../../redux/modal/modalSlice';
import { AccordionGroup } from './Accordion';
import saveIcon from '../../../images/iconGuardar.svg';
import iconoAdd from '../../../images/iconoAdd.svg';
import iconEditarLead from '../../../images/iconEditarLead.svg';
import { formatToCEP, formatToCurrency, formatToPercentage } from '../../../commonFunctions/FormatterFunctions';
import { errorHandler } from '../../../commonFunctions/errorHandler';
import { baseRequest } from '../../../fetch/basicThunk';
import { QUERY_POST_QUOTATION_BRANDMODEL_DELETE, QUERY_POST_QUOTATION_BRANDMODEL_UPDATE } from '../../../fetch/constantQueries';
import BrandModelDialog from './BrandModelDialog';

function ReadOnlyInput(props) {
  return (
    <div className={props.classStyle || 'input-wrapper-col'} style={props.expired ? { color: 'red' } : null}>
      <label>{props.label}</label>
      <div title={props.field?.length > 80 ? props.tooltip : null}>{props.date ? (props.field ? dayjs(props.field, 'DD/MM/YYYY').format('DD/MM/YYYY') : null) : props.field}</div>
    </div>
  );
}

function ReadOnlyModelInput(props) {
  return (
    <div className={props.classStyle || 'input-wrapper-col'} style={props.expired ? { ...props.style, color: 'red' } : { ...props.style }}>
      <label>
        {props.label}
        {props.showEditIcon && (
          <IconButton onClick={(e) => props.openEditForm(props.modelData)} style={{ padding: 5, marginLeft: 5 }}>
            <img src={iconEditarLead} alt="Editar modelo" title={'Editar modelo'} width={15} />
          </IconButton>
        )}
      </label>
      <div title={props.field?.length > 80 ? props.tooltip : null}>{props.date ? (props.field ? dayjs(props.field, 'DD/MM/YYYY').format('DD/MM/YYYY') : null) : props.field}</div>
    </div>
  );
}
function QuotationInfo() {
  const dispatch = useDispatch();
  const contract = useSelector(selectContract);
  const loadingContract = useSelector(selectContractLoading);
  const [brandModelDialogForm, setBrandModelDialogForm] = useState({});
  const [showBrandModelDialog, setShowBrandModelDialog] = useState(false);

  let generalInfo = [
    { label: 'Número', field: contract.case?.quotation?.quotationId },
    { label: 'Origem', field: contract.case?.quotation?.quotationType.toUpperCase() === 'PURCHASE' ? 'Compras' : (contract.case?.quotation?.quotationType.toUpperCase() === 'FINANCE' ? 'Financiamento' : contract.case?.quotation?.quotationType) },
    { label: 'Data Criação', field: dayjs(contract.case?.quotation?.createdAt).format('DD/MM/YYYY HH:mm') },
    { label: 'Status', field: contract.case?.quotation?.approved != null ? (contract.case?.quotation?.approved ? 'Cotação aprovada' : 'Cotação recusada') : 'Aprovação pendente!' },
  ];
  if(contract.case?.quotation?.approved != null){
    generalInfo.push({
      label: (contract.case?.quotation?.approved ? 'Data Aprovação' : 'Data Recusa'),
      field: dayjs(contract.case?.quotation?.approvalUpdatedAt).format('DD/MM/YYYY HH:mm'),
    })
  }

  let finnaceData = [
    { label: 'Tipo de plano', field: contract.case?.quotation?.finance?.financePlan },
    { label: 'Status', field: contract.case?.quotation?.finance?.approved != null ? (contract.case?.quotation?.finance?.approved ? 'Simulação aprovada' : 'Simulação recusada') : 'Aprovação pendente!' },
  ];
  if(contract.case?.quotation?.approved != null){
    finnaceData.push({
      label: (contract.case?.quotation?.finance?.approved ? 'Data Aprovação' : 'Data Recusa'),
      field: dayjs(contract.case?.quotation?.finance?.approvalUpdatedAt).format('DD/MM/YYYY HH:mm'),
    })
  }
  function closeBrandModelDialog() {
    setBrandModelDialogForm({});
    setShowBrandModelDialog(false);
  }
  function openBrandModelDialog(quotationBrandModel) {
    setBrandModelDialogForm((prevState) => ({
      ...prevState,
      ...quotationBrandModel,
    }));

    setShowBrandModelDialog(true);
  }
  function onChangeBrandModelDialogForm(main, value) {
    setBrandModelDialogForm((prevState) => ({ ...prevState, [main]: value }));
  }
  async function handleBrandModelDialogSubmit() {
    if (!brandModelDialogForm.quantity) {
      dispatch(openModal({ type: 'warning', message: `O campo quantidade é obrigatório` }));
      return false;
    }
    if (brandModelDialogForm.quantity && brandModelDialogForm.quantity < 1) {
      dispatch(openModal({ type: 'warning', message: `O campo quantidade deve ser maior que 0` }));
      return false;
    }
    // if (!brandModelDialogForm.disregardRebatePercent) {
    //   dispatch(openModal({ type: 'warning', message: `O campo quantidade é obrigatório` }));
    //   return false;
    // }
    if (brandModelDialogForm.disregardRebatePercent && brandModelDialogForm.disregardRebatePercent < 0) {
      dispatch(openModal({ type: 'warning', message: `O campo desconto inválido` }));
      return false;
    }
    if (!brandModelDialogForm.observations || brandModelDialogForm.observations.trim() === '') {
      dispatch(openModal({ type: 'warning', message: `O campo observações é obrigatório` }));
      return false;
    }
    try {
      const data = await baseRequest({ body: brandModelDialogForm }, dispatch, QUERY_POST_QUOTATION_BRANDMODEL_UPDATE, 'PUT');
      dispatch(openModal({ type: 'success', message: 'Modelo atualizado com sucesso!' }));
      dispatch(getContractByCaseId({ query: `?caseId=${contract.case.caseId}` }));
      closeBrandModelDialog();
    } catch (err) {
      dispatch(openModal(errorHandler(err)));
    }
  }
  async function handleBrandModelDialogDelete(id) {
    if (window.confirm('Gostaria realmente de excluir este modelo?')) {
      try {
        const data = await baseRequest({ param: id }, dispatch, QUERY_POST_QUOTATION_BRANDMODEL_DELETE, 'DELETE');
        dispatch(openModal({ type: 'success', message: 'Modelo excluído com sucesso!' }));
        dispatch(getContractByCaseId({ query: `?caseId=${contract.case.caseId}` }));
        closeBrandModelDialog();
      } catch (err) {
        dispatch(openModal(errorHandler(err)));
      }
    }
  }

  const brandAccordionContent = () => {
    let accordionData = [];

    contract.case?.quotation?.quotationBrands.map((data) =>
      accordionData.push({
        title: '',
        quotationId: contract.case?.quotation?.quotationId,
        replied: data.replied,
        brandName: data.brandName,
        body: (
          <>
            {data.quotationBrandModels.map((qbm) => (
              <Fragment key={qbm.modelName}>
                <ReadOnlyModelInput
                  key={'model-' + qbm.modelName}
                  label={'Modelo:'}
                  field={qbm.quantity + 'x - ' + qbm.modelName}
                  showEditIcon={true}
                  openEditForm={(e) => openBrandModelDialog(qbm)}
                  modelData={qbm}
                  style={{ alignItems: 'center' }}
                />
                <ReadOnlyInput key={'price-' + qbm.modelName} field={'Preço: ' + formatToCurrency(qbm.price)} classStyle={data.classStyle} tooltip={data.field} />
                {qbm.disregardRebatePercent && (
                  <ReadOnlyInput
                    key={'discountApplied-' + qbm.modelName}
                    field={'Desconsiderar rebate de ' + formatToPercentage(qbm.disregardRebatePercent)}
                    classStyle={data.classStyle}
                    tooltip={data.field}
                  />
                )}
                {qbm.observations && (
                  <ReadOnlyInput
                    key={'observations-' + qbm.modelName}
                    field={'Obs.: ' + qbm.observations}
                    span={data.span}
                    date={data.date}
                    expired={data.expired}
                    classStyle={data.classStyle}
                    tooltip={data.field}
                  />
                )}
              </Fragment>
            ))}
            <ReadOnlyInput
              key={'quotationReplied-' + data.brandName}
              label={'Cotação respondida?'}
              field={data.replied ? 'Sim' : 'Não'}
              expired={!data.replied}
              span={data.span}
              date={data.date}
              classStyle={data.classStyle}
              tooltip={data.field}
            />
          </>
        ),
      })
    );

    if (contract.case?.quotation?.finance) {
      accordionData.push({
        title: '',
        quotationId: contract.case?.quotation?.quotationId,
        financeId: contract.case?.quotation?.finance.financeId,
        body: finnaceData.map((e) => <ReadOnlyInput key={e.label} label={e.label} field={e.field} span={e.span} date={e.date} expired={e.expired} classStyle={e.classStyle} tooltip={e.field} />),
      });
    }

    return <AccordionGroup key="quotation" data={accordionData} />;

    // return (
    //   <>
    //     {contract.case?.quotation && (
    //       <Accordion
    //         dataSource={accordionData}
    //         collapsible
    //         multiple
    //         itemTitleRender={(data) => {
    //           return (
    //             <>
    //               <span style={{ fontSize: 13, fontWeight: 700, color: '#3B5158', marginRight: 15 }}>
    //                 {/* Cotação #{contract.case?.quotation?.quotationId} - Montadora: {data.brandName} */}
    //                 {data.title}
    //               </span>
    //               {/* {data.replied !== undefined && data.replied === false && <FontAwesomeIcon style={{ color: '#800000' }} icon={faHourglassHalf} />}
    //               {data.replied !== undefined && data.replied === true && <FontAwesomeIcon style={{ color: '#008000' }} icon={faCheck} />} */}
    //             </>
    //           );
    //         }}
    //         itemRender={(data) => {
    //           return (
    //             <div key={data.brandName} className="grid-contract">
    //               {data.body}
    //             </div>
    //           );
    //         }}
    //       />
    //     )}
    //   </>
    // );

    // return (
    //   <>
    //     {contract.case?.quotation && (
    //       <Accordion
    //         dataSource={contract.case?.quotation?.quotationBrands}
    //         collapsible
    //         multiple={false}
    //         // selectedItems={selectedBrandItems}
    //         // onSelectionChanged={selectionBrandChanged}
    //         itemTitleRender={(data) => {
    //           return (
    //             <>
    //               <span style={{ fontSize: 13, fontWeight: 700, color: '#3B5158', marginRight: 15 }}>
    //                 Cotação #{contract.case?.quotation?.quotationId} - Montadora: {data.brandName}
    //               </span>
    //               {data.replied !== undefined && data.replied === false && <FontAwesomeIcon style={{ color: '#800000' }} icon={faHourglassHalf} />}
    //               {data.replied !== undefined && data.replied === true && <FontAwesomeIcon style={{ color: '#008000' }} icon={faCheck} />}
    //             </>
    //           );
    //         }}
    //         itemRender={(data) => {
    //           return (
    //             <div key={data.brandName} className="grid-contract">
    //               <>
    //                 {data.quotationBrandModels.map((qbm) => (
    //                   <Fragment key={qbm.modelName}>
    //                     <ReadOnlyModelInput
    //                       key={'model-' + qbm.modelName}
    //                       label={'Modelo:'}
    //                       field={qbm.quantity + 'x - ' + qbm.modelName}
    //                       showEditIcon={true}
    //                       openEditForm={(e) => openBrandModelDialog(qbm)}
    //                       modelData={qbm}
    //                       style={{ alignItems: 'center' }}
    //                     />
    //                     <ReadOnlyInput key={'price-' + qbm.modelName} field={'Preço: ' + formatToCurrency(qbm.price)} classStyle={data.classStyle} tooltip={data.field} />
    //                     {qbm.disregardRebatePercent && (
    //                       <ReadOnlyInput
    //                         key={'discountApplied-' + qbm.modelName}
    //                         field={'Desconsiderar rebate de ' + formatToPercentage(qbm.disregardRebatePercent)}
    //                         classStyle={data.classStyle}
    //                         tooltip={data.field}
    //                       />
    //                     )}
    //                     {qbm.observations && (
    //                       <ReadOnlyInput
    //                         key={'observations-' + qbm.modelName}
    //                         field={'Obs.: ' + qbm.observations}
    //                         span={data.span}
    //                         date={data.date}
    //                         expired={data.expired}
    //                         classStyle={data.classStyle}
    //                         tooltip={data.field}
    //                       />
    //                     )}
    //                   </Fragment>
    //                 ))}
    //                 <ReadOnlyInput
    //                   key={'quotationReplied-' + data.brandName}
    //                   label={'Cotação respondida?'}
    //                   field={data.replied ? 'Sim' : 'Não'}
    //                   expired={!data.replied}
    //                   span={data.span}
    //                   date={data.date}
    //                   classStyle={data.classStyle}
    //                   tooltip={data.field}
    //                 />
    //               </>
    //             </div>
    //           );
    //         }}
    //       />
    //     )}
    //   </>
    // );
  };

  return (
    <>
      {contract?.case?.quotation != null && (
        <>
          <BrandModelDialog
            title={'Cotação - Editar Modelo'}
            dialogSize={{ height: '100%' }}
            open={showBrandModelDialog}
            onClose={closeBrandModelDialog}
            handleOnClick={handleBrandModelDialogSubmit}
            handleDelete={handleBrandModelDialogDelete}
            dataForm={brandModelDialogForm}
            onChange={onChangeBrandModelDialogForm}
          ></BrandModelDialog>

          <div className="grid-contract" style={{ marginTop: 10 }}>
            {generalInfo.map((e) => (
              <ReadOnlyInput key={e.label} label={e.label} field={e.field} span={e.span} date={e.date} expired={e.expired} classStyle={e.classStyle} tooltip={e.field} />
            ))}
          </div>

          {contract && brandAccordionContent()}
        </>
      )}
    </>
  );
}

export { QuotationInfo };
